import { FunctionComponent, PropsWithChildren } from 'react';
import styles from './SelectorListContainer.module.scss';
import clsx from 'clsx';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

interface SelectorListContainerProps extends PropsWithChildren {
    className?: string;
}

export const SelectorListContainer: FunctionComponent<SelectorListContainerProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <OverlayScrollbarsComponent style={{ maxHeight: '250px', padding: '0px 20px' }}>
                {props.children}
            </OverlayScrollbarsComponent>
        </div>
    );
};

export default SelectorListContainer;
